import {
  createSelectionService,
  SelectionService,
} from '@/libs/onboarding/services/selectionService';
import { authServiceInstance } from './authServiceInstance';
import type { SessionServiceType } from './apolloClient';
import { storageSvc } from './storageServiceClient';

export class SessionService implements SessionServiceType {
  private static instance: SessionService;
  private selectionService: SelectionService;

  private constructor() {
    this.selectionService = createSelectionService(storageSvc);
  }

  static getInstance(): SessionService {
    if (!SessionService.instance) {
      SessionService.instance = new SessionService();
    }
    return SessionService.instance;
  }

  async getHeaders(): Promise<Record<string, string>> {
    const session = await authServiceInstance.getCurrentSession();

    const authHeaders: Record<string, string> = {};
    if (session) {
      authHeaders.Authorization = session.tokens.access_token;
    }

    const customHeaders = this.getOrgHeaders();

    return {
      ...authHeaders,
      ...customHeaders,
    };
  }

  async getWSPayload(): Promise<Record<string, string>> {
    const session = await authServiceInstance.getCurrentSession();

    const payload: Record<string, string> = {};
    if (session) {
      payload.token = session.tokens.access_token;
    }

    const customHeaders = this.getOrgHeaders();

    return {
      ...payload,
      ...customHeaders,
    };
  }

  getOrgHeaders(): Record<string, string> {
    const options = this.selectionService.getSelectionState();

    const customHeaders: Record<string, string> = {};
    if (options.organization?.id) {
      customHeaders.organization = options.organization.id;
    }

    if (options.store?.venue?.id) {
      customHeaders.venue = options?.store.venue.id;
    }

    if (options.store?.id) {
      customHeaders.store = options.store.id;
    }

    return customHeaders;
  }

  async clearSession(): Promise<void> {
    // Only clear auth tokens
    await authServiceInstance.logout();
  }
}

export const sessionService = SessionService.getInstance();
